var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermIdentityOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PermIdentity",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 16,
    height: 16,
    fill: "#F7F5F5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#F7F5F5",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1764",
    "data-name": "Groupe 1764",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1763",
    "data-name": "Groupe 1763",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_409",
    "data-name": "Trac\\xE9 409",
    d: "M8,2A2,2,0,1,1,6,4,2.006,2.006,0,0,1,8,2m0,9c2.7,0,5.8,1.29,6,2v1H2v-.99C2.2,12.29,5.3,11,8,11M8,0a4,4,0,1,0,4,4A4,4,0,0,0,8,0M8,9c-2.67,0-8,1.34-8,4v3H16V13c0-2.66-5.33-4-8-4",
    fill: "#F7F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermIdentityOutlined);
export default __webpack_public_path__ + "static/media/PermIdentityOutlined.d8472d7ca856d62cabd31bf81fec5052.svg";
export { ForwardRef as ReactComponent };